import { ReactElement } from 'react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFCrumArrow from '@/components/UI/svg/Icons/EFCrumArrow';

type params = {
    title?: string; // 优先级较高，面包屑内容完全有外部决定 类似于 Home > Support > xx
    data?: { name: string; link?: string }[]; // 由数据生成面包屑，传入title时，该字段不生效
    separator?: string | ReactElement; // 自定义分隔符，仅限传入data时生效
    className?: string; // 扩展类名
    backgroundColor?: string; // 背景颜色
};
export default function Store({ title, data, separator, className = 'crumber', backgroundColor = '#ededed' }: params) {
    const { Link, isMobile } = useGlobal();
    return (
        <div className={`${css.crumber} crumber ${className} cover  ${isMobile ? 'crumber_h5' : 'crumber_pc'}`} style={{ background: backgroundColor }}>
            <div className={`box`}>
                {/* 兼容title写法 */}
                {title && <h2 className="crumb font-family-regular" dangerouslySetInnerHTML={{ __html: title }}></h2>}

                {/* 根据配置数据生成Breadcrumb*/}
                {!title && (
                    <h2 className="crumb font-family-regular">
                        {data?.map((item: any, index: number) => (
                            <div key={item.name} style={{ display: 'flex', alignItems: 'center' }}>
                                {data.length - 1 > index && (
                                    <>
                                        <Link
                                            className="GtmModuleData-btn-href"
                                            href={item.link.replace(/\/$/, ' ')}
                                            ariaLabel={item.name}
                                            dataLayer={{
                                                __btn_id1: css.crumber,
                                                __btn_id2: item.link.replace(/\/$/, ' '),
                                            }}
                                        >
                                            <span className="text links">{item.name}</span>
                                        </Link>
                                        {separator ? separator : <EFCrumArrow className="crumb-arr" />}
                                    </>
                                )}

                                {data.length - 1 <= index && (
                                    <a className="text" aria-label={item.name}>
                                        {item.name}
                                    </a>
                                )}
                            </div>
                        ))}
                    </h2>
                )}
            </div>
        </div>
    );
}
